import { useQuery } from "@rocicorp/zero/react"
import { IconListTreeOutline18 as SubIssuesIcon } from "nucleo-ui-outline-18"

import type { Issue } from "@productlane/zero"
import { queries } from "@productlane/zero/queries"

import { ProjectOrIssueListItem } from "@/components/issue-or-project-items/project-or-issue-list-item"

export const SubIssuesList = ({
	issue,
}: {
	issue: Pick<Issue, "linearTicketId">
}) => {
	const [subIssues] = useQuery(queries.subIssues(issue.linearTicketId))
	if (subIssues.length === 0) return null

	const maxPainLevel = Math.max(...subIssues.map((s) => s.totalScore))

	return (
		<div className="mt-2 md:px-5">
			<div className="mb-1 flex items-center gap-2 px-1 text-sm text-secondary">
				<SubIssuesIcon className="h-4 w-4 flex-none" />
				<span>Sub-issues</span>
				<span className="tabular-nums text-tertiary">{subIssues.length}</span>
			</div>
			{subIssues.map((subIssue) => (
				<ProjectOrIssueListItem
					key={subIssue.id}
					data={subIssue}
					type="issue"
					maxPainLevel={maxPainLevel}
					hidePriority={true}
				/>
			))}
		</div>
	)
}
